import { AppConfig } from "./../../AppConfig";
export const DetectBrand = {
  methods: {
    isBranded: function() {
      var brandBuildVar = AppConfig.isBranded;
      if (brandBuildVar != "true" && brandBuildVar != "false") {
        brandBuildVar = "true";
      }
      var isBranded =
        process.env.NODE_ENV === "production" ? brandBuildVar : "false";
      return isBranded === "true" ? true : false;
    },
  },
};
